import { useEffect, useState } from "react";
import { BadgeCheck, CalendarDays, ExternalLink, MessageCircle } from "lucide-react";
import { api, waLink } from "@/lib/api";
import { scrollTo } from "@/components/Nav";
import { Link } from "react-router-dom";
import MyBills from "@/components/account/MyBills";

const STATUS = {
  new: { label: "Received", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  contacted: { label: "In discussion", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  confirmed: { label: "Confirmed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export default function MyTrips() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/customer/enquiries").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  if (!rows) return <p className="text-sm text-ink/50" data-testid="trips-loading">Loading your trips…</p>;
  if (!rows.length) {
    return (
      <div>
        <div className="bg-white border border-ink/10 rounded-3xl p-10 text-center" data-testid="trips-empty">
        <p className="font-serif text-2xl font-bold">No trips yet</p>
        <p className="mt-2 text-sm text-ink/60">Bookings and enquiries you make while signed in show up here with live status and your confirmation card.</p>
        <Link to="/" onClick={() => setTimeout(() => scrollTo("#tours"), 300)} className="mt-6 inline-block bg-ink text-sand text-sm font-semibold px-5 py-3 rounded-full hover:bg-terra transition-colors" data-testid="trips-browse-button">Browse Puri tours</Link>
        </div>
        <MyBills />
      </div>
    );
  }
  return (
    <div>
      <div className="grid grid-cols-1 gap-4" data-testid="trips-list">
      {rows.map((e) => {
        const st = STATUS[e.status] || STATUS.new;
        const what = e.vehicle_name || e.service;
        return (
          <div key={e.id} className="bg-white border border-ink/10 rounded-3xl p-6 flex flex-wrap items-start justify-between gap-4" data-testid={`trip-row-${e.id.slice(0, 8)}`}>
            <div>
              <span className={`inline-block text-[11px] font-semibold px-2.5 py-1 rounded-full border ${st.cls}`} data-testid={`trip-status-${e.id.slice(0, 8)}`}>{st.label}</span>
              <p className="font-serif text-xl font-bold mt-2">{what}</p>
              <p className="text-sm text-ink/60 mt-1 flex flex-wrap items-center gap-x-3">
                {(e.booking_date || e.travel_dates) && <span className="inline-flex items-center gap-1"><CalendarDays size={13} /> {e.booking_date || e.travel_dates}</span>}
                {e.duration_hours > 0 && <span>{e.duration_hours} hrs</span>}
                {(e.amount || e.estimate) > 0 && <span>₹{Number(e.amount || e.estimate).toLocaleString("en-IN")}</span>}
              </p>
              {e.pickup_note && <p className="text-xs text-ink/60 mt-2">Pickup: {e.pickup_note}</p>}
              <p className="text-[11px] text-ink/40 mt-2 font-mono">Requested {new Date(e.created_at).toLocaleDateString("en-IN")}</p>
            </div>
            <div className="flex flex-col gap-2">
              {e.confirmation_url && (
                <a href={e.confirmation_url} target="_blank" rel="noreferrer" data-testid={`trip-confirmation-${e.id.slice(0, 8)}`}
                  className="inline-flex items-center gap-1.5 bg-ink text-sand text-xs font-semibold px-4 py-2 rounded-full hover:bg-terra transition-colors"><BadgeCheck size={13} /> Confirmation card <ExternalLink size={11} /></a>
              )}
              <a href={waLink(`Hi Random Rider! About my ${what} request${e.booking_date ? ` for ${e.booking_date}` : ""} (ref ${e.id.slice(0, 8)}).`)} target="_blank" rel="noreferrer" data-testid={`trip-whatsapp-${e.id.slice(0, 8)}`}
                className="inline-flex items-center gap-1.5 border border-ink/15 text-xs font-semibold px-4 py-2 rounded-full hover:bg-sand transition-colors"><MessageCircle size={13} /> Chat about this</a>
            </div>
          </div>
        );
      })}
      </div>
      <MyBills />
    </div>
  );
}
